var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: 'relative min-h-full px-8 pt-5 pb-5 rounded-md ' + _vm.colorTemplate.background + ' ' + _vm.colorTemplate.shadow,
    on: {
      "mouseleave": function ($event) {
        _vm.hideFiligrane();
        _vm.closeMore();
      },
      "mouseenter": function ($event) {
        return _vm.showFiligrane();
      }
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.isFiligrane ? _c('div', {
    staticClass: "top-0 left-0 bg-indigo-600 bg-opacity-85 absolute w-full h-full rounded-md p-6 z-20 flex justify-center items-center cursor-default"
  }, [!_vm.isMoreDisplayed ? _c('div', {
    staticClass: "absolute right-4 top-4 p-2 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.displayMore();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "more-vertical"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isMoreDisplayed ? _c('div', {
    staticClass: "absolute right-6 top-6 flex space-x-3"
  }, [_vm.canEdit && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_MOVE) ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.moveFolder();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white transform",
    attrs: {
      "name": "foldermove"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isAdmin && _vm.canEdit && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_SHARE) && !_vm.$freeParticulier() ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.addMember();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "person-add"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.downloadFolder.apply(null, arguments);
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "download"
    }
  })], 1), _vm._v(" "), _vm.canEdit && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_EDIT) ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.editFolder();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "edit"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.canEdit && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_DELETE) ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.deleteFolder();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "trash-2"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "border border-pink-600 rounded-full py-1.5 px-3.5 flex justify-center text-center text-white text-base w-max cursor-pointer transition-all duration-300 hover:bg-white hover:text-indigo-600",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.openFolder();
      }
    }
  }, [_vm._v("\n        Ouvrir le dossier\n      ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-3 items-baseline h-16"
  }, [_c('icon', {
    class: _vm.colorTemplate.icon + ' w-5 h-5',
    attrs: {
      "name": _vm.isOwner ? 'folder-propriete' : 'folder'
    }
  }), _vm._v(" "), _c('h5', {
    class: _vm.colorTemplate.title + ' leading-6 text-left'
  }, [_vm._v("\n      " + _vm._s(_vm.folderName) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    class: _vm.colorTemplate.line + ' border-b my-4'
  }), _vm._v(" "), _c('div', {
    class: !_vm.smaller ? 'grid grid-cols-2 gap-2 items-center' : ''
  }, [_c('div', {
    class: (_vm.smaller ? 'grid grid-rows-4' : 'col-span-1 grid grid-rows-3') + ' gap-y-1'
  }, [_vm.nbFolders > 0 ? _c('div', {
    staticClass: "row-span-1 flex items-center space-x-1.5"
  }, [_c('icon', {
    staticClass: "text-gray-900 h-4",
    attrs: {
      "name": "folder"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-base"
  }, [_vm._v("\n          " + _vm._s(_vm.nbFolders) + " dossier"), _vm.nbFolders > 1 ? _c('span', [_vm._v("s")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _vm.nbFiles > 0 ? _c('div', {
    staticClass: "row-span-1 flex items-center space-x-1.5"
  }, [_c('icon', {
    staticClass: "text-gray-900 w-4 h-4",
    attrs: {
      "name": "file"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-base"
  }, [_vm._v("\n          " + _vm._s(_vm.nbFiles) + " fichier"), _vm.nbFiles > 1 ? _c('span', [_vm._v("s")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-span-1 flex items-center space-x-1.5"
  }, [_c('icon', {
    staticClass: "text-gray-600 w-4 h-4",
    attrs: {
      "name": "clock"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-base text-gray-600 italic font-light"
  }, [_vm._v("\n          " + _vm._s(_vm.createdDate.toLocaleDateString()) + "\n        ")])], 1), _vm._v(" "), _vm.smaller ? _c('list-avatars', {
    staticClass: "row-span-1 justify-self-end right-7",
    attrs: {
      "list-items": _vm.sharedWith,
      "libelle-firstname": "firstname",
      "libelle-lastname": "lastname"
    }
  }) : _vm._e()], 1), _vm._v(" "), !_vm.smaller ? _c('list-avatars', {
    staticClass: "col-span-1 justify-self-end right-9 mb-1/4",
    attrs: {
      "list-items": _vm.sharedWith,
      "libelle-firstname": "firstname",
      "libelle-lastname": "lastname"
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }